import {
  getCompanyInfoApi,
  getJoinCompanyApi,
  getPermsApi,
  getUserCompanyInfoApi,
  getUserInfoApi,
  toOpenCcCenterApi,
} from '~/api/system'
import { isDev } from '~/utils'

export const useMyUserStore = defineStore('myUserStore', {
  state: () => ({
    userId: null,
    userInfo: null as any,
    userIsMain: null,
    userNameCn: null,
    userNameEn: null,

    compVips: null as any,
    compInfo: null as any,
    compStatus: null,
    companyNameCn: null,
    companyNameEn: null,

    tradeFlag: false, //  用户交易权限true有；false没有（默认没登陆的时候没有交易权限）
    shopStatus: null,
    settleStatus: null, // 入驻状态 0 初始， 1 入驻中， 2 已驳回， 3 已入驻
    auditFlag: null, // 商铺审核状态 0 正常， 1 新建待审核， 2 信息异常 人工复审驳回
    isShopCustomerService: false, // 是否为商铺指定客服
    compId: null, // 当前登陆用户公司ID

    joinCompanyInfo: null, // 加入公司待审核信息
  }),
  getters: {
    currentUserId: (state) => {
      return state.userId
    },
    isChinese: (state) => {
      const countryIdList = [1, 71, 75, 100]
      return countryIdList.includes(state.compInfo?.countryId || 1)
    },
    currentCountryId: (state) => {
      return state?.compInfo?.countryId || 1
    },
    isLogin: (state) => {
      return state.userId !== null
    },
  },
  actions: {
    /**
     * 重置用户状态
     *
     * 此方法用于将用户的ID和信息重置为null，以便注销用户或清理用户状态
     */
    resetUser() {
      this.userId = null
      this.userInfo = null
    },

    /**
     * 重置用户和公司信息字段
     * */
    resetUserCompInfo() {
      this.userId = null
      this.userInfo = null
      this.userNameCn = null
      this.userNameEn = null
      this.userIsMain = null

      this.compVips = null
      this.compInfo = null
      this.companyNameCn = null
      this.companyNameEn = null
      this.compStatus = null

      this.tradeFlag = false
      this.shopStatus = null
      this.settleStatus = null
      this.auditFlag = null
    },

    /**
     * 获取用户和公司信息
     * 此函数根据用户ID获取最新的用户和公司信息
     * 它会检查是否需要强制刷新公司信息
     *
     * @param compInfoRefreshFlag - 是否强制刷新公司信息，默认为false
     */
    async getUserCompanyInfo(compInfoRefreshFlag = false) {
      let needRetryComp = true
      let needRetryUser = true

      // 如果没有用户id，则直接走默认请求流程
      if (!this.userId) {
        needRetryComp = false
        needRetryUser = false

        if (isDev()) {
          const data: any = {
            account: {
              version: 100,
              userId: 5006032,
              userName: '李颖1(liying2)',
              isMain: '1',
              status: '0',
              fromSys: 'TPS',
              auditFlag: '0',
              gender: '1',
              nameCn: '李颖1',
              nameEn: 'liying2',
              jobTitleCn: '前端开发工程师',
              jobTitleEn: 'dev123',
              headPortrait:
                'https://resources.jctrans.com/res/account/pc/img/default_avator.png',
              whatsapp: '333ssssss',
              account: 'liying1',
              mobile: '3e38LqtA7PlnAo8TIMqWKA==',
              mobileValidFlag: '1',
              areaCode: '+86',
              countryId: 1,
              email: 'W1RbJOYlksfSIcOabXHoCEUvJiGyeCimLq97EsxdkBg=',
              emailValidFlag: '1',
              createTime: '2022-06-29T11:54:08',
              jcpayFlag: '1',
            },
            company: {
              version: 125,
              compId: 5006000,
              compName: 'sadadfwfawf(jctrans-en-company)',
              verificated: '1',
              status: '0',
              violationStatus: '0',
              auditFlag: '0',
              fromSys: 'TPS',
              transactionStatus: '2',
              memberCode: '123',
              nameCn: 'sadadfwfawf',
              nameEn: 'jctrans-en-company',
              countryId: 1,
              cityId: 2667,
              countryNameCn: '中国',
              countryNameEn: 'China',
              cityNameCn: '唐山',
              cityNameEn: 'Tangshan',
              scale: 'large',
              estabYears: '2023-12-11',
              registeredAddressCn: '发发发',
              registeredAddressEn: 'asdasd',
              officeAddressCn: 'qq',
              officeAddressEn: 'qq',
              industrySector: 'Logistics',
              tel: '13124272234',
              logoFile:
                'https://wlw-obs-dev-bj4n.obs.cn-north-4.myhuaweicloud.com:443/COMPANY_LOGO%2Fbc41eace-7faf-4c06-ada8-40a1c9b94129',
              twitter: '123456',
              youtube: '00923',
              facebook: 'facebook',
              linkedIn: 'linked',
              compVips: [
                {
                  name: 'JC Premium',
                  code: 'GCP',
                  start: '2024-12-13',
                  expireAt: '2025-12-12',
                  yearsAddUp: 1,
                  vipType: '4',
                  vipCertificateWeb:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/2f3de9c8-0c3d-474e-8e7d-7971591ece60.png',
                  vipCertificatePrint:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/99beb61e-69f3-485d-bbee-4293e9e3ed4a.png',
                  vipLogoFile:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
                  vipCertificateLogo:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/e2151735-84cf-48db-8c31-e6db8dd5cc21.png',
                },
                {
                  name: 'JC eCommerce',
                  code: 'JC eCommerce',
                  start: '2024-12-13',
                  expireAt: '2025-12-12',
                  yearsAddUp: 1,
                  vipType: '4',
                  vipCertificateWeb:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/5584c2e7-d16f-4659-a110-aa9cf16b59f1.png',
                  vipCertificatePrint:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b978665d-91e7-4642-bfa4-0ba6176b103d.png',
                  vipLogoFile:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
                  vipCertificateLogo:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/dff5031b-44ce-40b5-bb28-cc0921ab8ade.png',
                },
                {
                  name: 'JC Railway',
                  code: 'JC Railway',
                  start: '2024-12-13',
                  expireAt: '2025-12-12',
                  yearsAddUp: 1,
                  vipType: '4',
                  vipCertificateWeb:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/fc8e5efd-b7b2-4622-848d-1a7b59b6a77b.png',
                  vipCertificatePrint:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/dc381aaf-5eb5-4713-b462-2a3d9324cccf.png',
                  vipLogoFile:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
                  vipCertificateLogo:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/00496e17-4040-4593-b113-452650720c7c.png',
                },
                {
                  name: 'JC Vendor Transportation',
                  code: 'JC Vendor Transportation',
                  start: '2024-12-13',
                  expireAt: '2025-12-12',
                  yearsAddUp: 1,
                  vipType: '4',
                  vipCertificateWeb:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/8901c0eb-5a22-4f7c-a4f8-0df9f9ba5fc1.png',
                  vipCertificatePrint:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/97d626e6-ad71-4f5c-a55c-2005d6aaab14.png',
                  vipLogoFile:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
                  vipCertificateLogo:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/5cfe9f2e-2030-4e3d-b70d-ec7bb643b143.png',
                },
                {
                  name: 'JC Vendor Warehousing',
                  code: 'JC Vendor Warehousing',
                  start: '2024-12-13',
                  expireAt: '2025-12-12',
                  yearsAddUp: 1,
                  vipType: '4',
                  vipCertificateWeb:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/87865115-7e46-4be4-944b-242e8b5dcdc3.png',
                  vipCertificatePrint:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/8ff60065-f003-49f8-b1b4-bcbf8f3282ea.png',
                  vipLogoFile:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
                  vipCertificateLogo:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/e8b1e7bf-4dff-46ce-be6b-2d18d69a722a.png',
                },
                {
                  name: 'TSP',
                  code: 'TSP',
                  start: '2024-12-13',
                  expireAt: '2025-12-12',
                  yearsAddUp: 2,
                  vipType: '4',
                  vipCertificateWeb:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/4558fdc4-b663-4d2f-8eb2-b24cddffb92e.png',
                  vipCertificatePrint:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/ff70a31b-9e88-4685-a98c-276f535b8bd2.png',
                  vipLogoFile:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/b2a212e3-51db-407b-ba73-c328bcbd94d9.png',
                  vipCertificateLogo:
                    'https://assets-dev.jctrans.com/COMMON_IMG_GEN/d166e42a-132d-4172-aadd-8cb8dd14161c.png',
                },
              ],

              compTags: [],
              regCapital: '554',
              registeredNumber: 'adasd',
              historyVips: ['GCP'],
              jcpayFlag: '1',
            },
          }

          // 更新用户信息
          this.userId = data.account.userId
          this.userInfo = data.account
          this.userIsMain = data.account.isMain

          this.userNameCn = data.account.nameCn
          this.userNameEn = data.account.nameEn

          // 如果数据中包含公司信息，则同时更新公司信息
          if (data.company) {
            this.compVips = data.company.compVips

            this.compInfo = data.company ?? {}
            this.compStatus = data.company.status
            this.companyNameCn = data.company.nameCn
            this.companyNameEn = data.company.nameEn
          }
        } else {
          getUserCompanyInfoApi()
            .then((res: any) => {
              const { data } = res
              // 更新用户信息
              this.userId = data.account.userId
              this.userInfo = data.account
              this.userIsMain = data.account.isMain

              this.userNameCn = data.account.nameCn
              this.userNameEn = data.account.nameEn

              // 如果数据中包含公司信息，则同时更新公司信息
              if (data.company) {
                this.compVips = data.company.compVips

                this.compInfo = data.company ?? {}
                this.compStatus = data.company.status
                this.companyNameCn = data.company.nameCn
                this.companyNameEn = data.company.nameEn
              }
            })
            .catch((err) => {
              console.error('获取用户和公司信息时出错:', err)
            })
        }
      }

      // 如果需要重试获取公司信息
      if (needRetryComp) {
        let params
        // 如果设置了强制刷新公司信息标志，则传空参数强制请求
        if (compInfoRefreshFlag) {
          params = {}
        }
        // 如果当前用户已有公司信息，则基于现有信息请求更新
        else if (this.compInfo) {
          params = {
            id: this.compInfo.compId,
            version: this.compInfo.version,
          }
        }
        // 如果既没有公司信息又没有强制刷新标志，则不执行任何操作
        else {
          return
        }
        getCompanyInfoApi(params).then((res: any) => {
          const { data, subcode } = res
          // 根据返回的子码处理不同的情况
          if (subcode === 'UPDATED') {
            // 公司信息已更新
            this.compVips = data.compVips
            this.compInfo = data
            this.compStatus = data.status
            this.companyNameCn = data.nameCn ?? ''
            this.companyNameEn = data.nameEn ?? ''
          }
          if (subcode === 'UNCHANGED') {
            // 公司信息未变更
            this.compInfo = { ...this.compInfo, ...data }
          }
          if (subcode === 'NOTFOUND') {
            // 未找到公司信息
            this.compVips = null
            this.compInfo = null
            this.compStatus = null
            this.companyNameCn = null
            this.companyNameEn = null
          }
        })
      }

      // 如果需要重试获取用户信息
      if (needRetryUser) {
        getUserInfoApi({
          id: this.userId,
          version: this.userInfo.version,
        }).then(({ data, subcode }: any) => {
          // 根据返回的子码处理不同的情况
          if (subcode === 'UPDATED') {
            // 用户信息已更新
            this.userId = data.userId
            this.userInfo = data
            this.userIsMain = data.isMain
            this.userNameCn = data.nameCn
            this.userNameEn = data.nameEn
          }
          if (subcode === 'UNCHANGED') {
            // 用户信息未变更
            this.userIsMain = data.isMain
            this.userInfo = {
              ...this.userInfo,
              ...data,
            }
          }
        })
      }
    },

    /**
     * 异步获取权限信息
     *
     * 此方法旨在根据当前环境（开发或生产）来获取相应的权限信息
     * 在开发环境中直接返回一组固定的数据，用于模拟权限信息
     * 在生产环境中，则通过调用后端接口来获取实际的权限信息
     */
    async getPermsInfo() {
      let data = null
      // 在开发环境中，直接返回模拟的权限信息
      if (isDev()) {
        data = {
          compId: 5006000,
          shopStatus: '0',
          settleStatus: '3',
          auditFlag: '0',
          trxFlag: '1',
        }
      } else {
        // 在生产环境中，通过调用接口获取权限信息
        const res: any = await getPermsApi()
        data = JSON.parse(res?.data || '{}')

        // 解析数据并更新当前对象的状态
        this.tradeFlag = data.trxFlag === '1'
        this.shopStatus = data.shopStatus
        this.auditFlag = data.auditFlag
        this.settleStatus = data.settleStatus
        this.compId = data.compId

        // 验证用户是否为商铺指定客服
        if (this.compId) {
          await toOpenCcCenterApi({ compId: this.compId }).then((res: any) => {
            const flag = res?.code === 0 && res.data === true
            this.isShopCustomerService = flag
          })
        }
      }
    },

    // 获取是否加入公司待审核状态
    getJoinCompanyAudit() {
      return new Promise((resolve, reject) => {
        getJoinCompanyApi()
          .then((res: any) => {
            this.joinCompanyInfo = res.data
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  persist: {
    storage: persistedState.localStorage,
  },
})
